export function initNavigation() {
    const mql = window.matchMedia('(max-width: 767px)');
    const userMenuBtn = document.getElementById('toggle-user-menu');
    const userMenuTarget = document.getElementById('user-menu');
    const menu = document.getElementById('menu');
    if (!userMenuBtn || !userMenuTarget || !menu) {
        // eslint-disable-next-line no-console
        console.warn("Expected to find required menu elements but didn't");
        return;
    }

    let hasMenuButton = false;

    function closeMenu(button, target) {
        button.setAttribute('aria-expanded', 'false');
        target.setAttribute('aria-hidden', 'true');
    }

    function toggleButton(button, target) {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        target.setAttribute('aria-hidden', String(expanded));
    }

    function attachMobileButton() {
        const menuButton = document.createElement('button');
        const wrapper = document.getElementsByClassName('nav--primary')[0];
        const span = document.createElement('span');
        menuButton.setAttribute('type', 'button');
        menuButton.setAttribute('id', 'menu-button');
        menuButton.setAttribute('aria-controls', 'menu');
        menuButton.setAttribute('aria-expanded', 'false');
        span.append('Menu');
        menuButton.append(span);
        menu?.setAttribute('aria-hidden', 'true');
        wrapper.insertBefore(menuButton, menu);
        hasMenuButton = true;
        menuButton.onclick = () => {
            toggleButton(menuButton, menu);
        };
    }

    userMenuBtn.onclick = () => {
        toggleButton(userMenuBtn, userMenuTarget);
    };

    if (mql.matches) {
        attachMobileButton();
    }

    mql.addEventListener('change', event => {
        if (event.matches && !hasMenuButton) {
            attachMobileButton();
        } else if (hasMenuButton) {
            const domButton = document.getElementById('menu-button');
            domButton?.remove();
            menu.removeAttribute('aria-hidden');
            hasMenuButton = false;
        }
    });

    document.addEventListener('click', function clickListener(event) {
        if (!userMenuBtn.contains(event.target as Node)) {
            closeMenu(userMenuBtn, userMenuTarget);
        }
    });
}
